import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import Icon from '../../../common/Icon';

const CheckoutEmptyCart = ({ checkoutStore }) => {
  const updateOrder = () => checkoutStore.updateOrder({module: CheckoutPageModule.CART_MODULE});

  return (
    <div className="CheckoutEmptyCart">
      <div className="CheckoutEmptyCart__icon">
        <Icon name="shopping-cart" />
      </div>
      <div className="CheckoutEmptyCart__message">
        <p className='CheckoutEmptyCart__message-cart'>
          <FormattedMessage
            id="checkout.emptyCart.messageCart"
            defaultMessage="Your shopping cart is empty."
          />
        </p>
        <p className='CheckoutEmptyCart__message-info'>
          <FormattedMessage
            id="checkout.emptyCart.messageInfo"
            defaultMessage="You can add products to your cart from the product categories of the online store."
          />
        </p>
      </div>
      <div className="CheckoutEmptyCart__start-shopping-button">
        <Link to="/">
          <Button
            onClick={updateOrder}
          >
            <FormattedMessage
            id="checkout.emptyCart.startShopping"
            defaultMessage="Start shopping"
            />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default inject('checkoutStore')(observer(CheckoutEmptyCart));
